<template>
  <div class="modal-emergency-msg-form">
    <b-modal
      ref="modal-emergency-msg"
      id="modal-emergency-msg"
      title="Mensaje de emergencia"
    >
      <div class="modal-body">
        <div class="form-group">
          <label>Ingrese el mensaje de emergencia</label>
          <input
            type="text"
            class="form-control"
            v-model="messageEmergency"
            required
          />
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" class="text-white" @click="aceptar">
          {{ btnAceptarModificar }}
        </b-button>
        <b-button
          variant="warning"
          class="text-white"
          @click="detener"
          v-if="showBtnDetener"
        >
          Detener
        </b-button>
        <b-button variant="secondary" class="text-white" @click="cancel">
          Cerrar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import firebaseService, { EventBus } from "../services/emergencyMessage";

export default {
  data() {
    return {
      messageEmergency: "",
      showBtnDetener: false,
      btnAceptarModificar: "Ingresar",
      showModalEmergencyMsg: false
    };
  },
  created() {
    firebaseService.getEmergencyMsg();

    EventBus.$on("eventBusEmergencyMsg", (value) => {
      if (value.trim().length > 0) {
        this.showModalEmergencyMsg = true;
        this.showBtnDetener = true;
        this.messageEmergency = value;
        this.btnAceptarModificar = "Modificar";
      } else {
        this.showModalEmergencyMsg = false;        
        this.showBtnDetener = false;
        this.messageEmergency = "";
        this.btnAceptarModificar = "Ingresar";
      }
    });
  },
  methods: {
    aceptar() {
      if (this.messageEmergency.trim().length <= 0) return;
      firebaseService.setEmergencyMsg(this.messageEmergency);
      this.$refs["modal-emergency-msg"].hide();
    },
    detener() {
      firebaseService.setEmergencyMsg("");
      this.$refs["modal-emergency-msg"].hide();
    },
    cancel() {
      this.$refs["modal-emergency-msg"].hide();
    }
  },
  beforeDestroy() {
    EventBus.$off("eventBusEmergencyMsg");
  },
};
</script>
